import {
  Typography,
  Box,
  Divider,
  Chip,
  Stack,
  Grid,
} from "@mui/material";

const GanaConSalazarInfo = () => {
  return (
    <Grid item  xs={12} xl={12} lg={12} sm={12} p={4}>
         <Box
            sx={{
              p: 4,
              borderRadius: 4,
              boxShadow: 3,
              backgroundColor: '#000',
              maxWidth: 600,
              margin: '0 auto',
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              fontStyle="italic"
              gutterBottom
            >
              🥇 1er premio: Horse Rayas Locas 150cc 2025 0KM.
            </Typography>

            <Divider sx={{ my: 2 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              fontStyle="italic"
              gutterBottom
            >
              🥈 2do premio: BRF modelo nuevo 150cc 2025 0KM.
            </Typography>

            <Divider sx={{ my: 2 }} />
            <Typography
              variant="h6"
              fontWeight="bold"
              fontStyle="italic"
              gutterBottom
            >
              🥉 3er premio: 300 dólares para el que más tickets compre.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="body1" color="text.secondary" gutterBottom>
              ⏳ <strong>Se anunciara la fecha del sorteo cuando se llegue al 90% de los tickets vendidos</strong><br />
              📍 Lotería Super Gana - 10pm
            </Typography>
          </Box>
          </Grid>
  );
};

export default GanaConSalazarInfo;
